import { MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
// Prominent disclosure shown BEFORE the OS location prompt. Both Apple (5.1.5)
// and Google Play require this for background location: it must name
// "location", say that tracking continues in the background, and name the
// feature it powers, in normal app flow rather than buried in a privacy policy.
//
// Controlled by the caller rather than reading useTripTracker, because
// TripTrackerProvider is not mounted anywhere yet and this component sat as
// dead code as a result. MileageTracker drives it today; the provider can drive
// it too once it's wired up.
export function BackgroundLocationDisclosure({
  open,
  onConfirm,
  onDismiss,
}: {
  open: boolean;
  onConfirm: () => void;
  onDismiss: () => void;
}) {
  return (
    <Dialog open={open} onOpenChange={(next) => !next && onDismiss()}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10">
            <MapPin className="h-6 w-6 text-primary" />
          </div>
          <DialogTitle className="text-center">Track mileage in the background</DialogTitle>
          <DialogDescription className="text-left">
            When you tap <span className="font-medium">Start trip</span>, Stoop collects your
            <span className="font-medium"> location</span> — including
            <span className="font-medium"> in the background, while the app is closed or your screen is off</span> — to
            measure the miles you drive and log them as a tax write-off.
            <br />
            <br />
            Tracking only runs between when you tap Start and Stop (or when you return to where you started). A
            notification shows while a trip is active. We never sell your location, and you can use the rest of Stoop
            without this.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-col gap-2 sm:flex-col">
          <Button className="w-full" onClick={onConfirm}>
            Allow & start trip
          </Button>
          <Button variant="ghost" className="w-full" onClick={onDismiss}>
            Not now
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
